import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppContext } from '../context';

const PrivateRoute = ({
  component: Component,
  dependsOn = 'setContext',
  blockIf = '',
  reference: ref,
  ...rest
}) => {
  const context = useContext(AppContext);

  return (
    <Route
      {...rest}
      render={props =>
        !context[blockIf] && context[dependsOn] ? (
          <Component {...props} ref={ref} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
